import React, { useState, useEffect } from 'react';
import { Typography, Grid, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import PropertyCard from '../PropertyCard';
import PropertyMap from '../PropertyMap';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		overflow: 'visible'
	},
	firstTitle: {
		margin: '0.4rem 0',
		paddingBottom: 10
	},
	noActiveTitle: {
		color: theme.palette.grey['KN_light_grey'],
		textAlign: 'center',
		lineHeight: 2
	},
	centerItem: {
		marginTop: 40,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%'
	}
}));

export default function NearbySoldTab({ listing, soldListings, isLoadingSoldListings }) {
	const classes = useStyles();

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
	const [isMobileGoogleMap, setIsMobileGoogleMap] = useState(window.innerWidth <= 960);
	const [selectedMapListing, setSelectedMapListing] = useState(null);

	useEffect(() => {
		function handleResize() {
			setIsMobile(window.innerWidth <= 600);
		}

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		function handleResize() {
			setIsMobileGoogleMap(window.innerWidth <= 960);
		}

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleSelectedMapListing = (selectedListingLocation) => {
		setSelectedMapListing(selectedListingLocation);
	};

	return isLoadingSoldListings ? (
		<div className={classes.centerItem}>
			<CircularProgress />
		</div>
	) : (
		<div className={classes.root}>
			{soldListings.length === 0 ? (
				<Typography
					variant="h4"
					component="h4"
					className={`${classes.centerItem} ${classes.noActiveTitle}`}
				>
					We searched high and low, but no nearby sold listings in sight. Fear not, we'll
					keep watching!
				</Typography>
			) : (
				<>
					<Typography variant="h4" component="h4" className={classes.firstTitle}>
						Nearby Sold Listings
					</Typography>
					<Grid container spacing={2}>
						{isMobileGoogleMap ? (
							<>
								<Grid item xs={12} md={6}>
									<PropertyMap
										currentPropertyLocation={listing.location}
										otherListings={soldListings}
										handleSelectedMapListing={handleSelectedMapListing}
									/>
								</Grid>
								<Grid item xs={12} md={6}>
									<PropertyCard
										listingCardInfo={soldListings}
										isMobile={isMobile}
										selectedMapListing={selectedMapListing}
										isNearBySold={true}
									/>
								</Grid>
							</>
						) : (
							<>
								<Grid item xs={12} md={6}>
									<PropertyCard
										listingCardInfo={soldListings}
										isMobile={isMobile}
										selectedMapListing={selectedMapListing}
										isNearBySold={true}
									/>
								</Grid>
								<Grid item xs={12} md={6}>
									<PropertyMap
										currentPropertyLocation={listing.location}
										otherListings={soldListings}
										handleSelectedMapListing={handleSelectedMapListing}
									/>
								</Grid>
							</>
						)}
					</Grid>
				</>
			)}
		</div>
	);
}
